var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"btn-group"},[_vm._l((_vm.btnList),function(item){return _c('span',{key:item,staticClass:"btn"},[((_vm.showText(item) == '确认批次' || _vm.showText(item) == '出库审批') && _vm.number)?_c('el-badge',{staticClass:"item",attrs:{"value":_vm.number}},[_c('el-button',{staticClass:"mr-10",attrs:{"size":"small"},on:{"click":function($event){_vm.goCheck(_vm.showText(item))}}},[_vm._v(" "+_vm._s(_vm.showText(item).split(',')[0])+" ")])],1):(item.split(',').length == 1 || _vm.$checkPermission(item.split(',')[1].trim()))?_c('el-button',{staticClass:"mr-10",attrs:{"type":_vm.showText(item).indexOf('添加') > -1 ||
        _vm.showText(item) == '支付' ||
        _vm.showText(item) == '发布供应' ||
        _vm.showText(item) == '发布需求' ||
        _vm.showText(item).indexOf('忽略') > -1 ||
        _vm.showText(item).indexOf('入库') > -1 ||
        (_vm.showText(item).indexOf('出库') > -1 && _vm.showText(item) != '出库审批') ||
        _vm.showText(item).indexOf('发布商品') > -1
          ? 'primary'
          : _vm.showText(item).indexOf('审批人') > -1
          ? 'info'
          : '',"size":"small"},on:{"click":function($event){_vm.goCheck(_vm.showText(item))}}},[(
          _vm.showText(item).indexOf('添加') > -1 ||
          _vm.showText(item) == '支付' ||
          _vm.showText(item) == '发布供应' ||
          _vm.showText(item) == '发布需求' ||
          _vm.showText(item).indexOf('入库') > -1 ||
          (_vm.showText(item).indexOf('出库') > -1 && _vm.showText(item) != '出库审批') ||
          _vm.showText(item).indexOf('发布商品') > -1
        )?_c('i',{staticClass:"el-icon-plus"}):_vm._e(),_vm._v(" "+_vm._s(_vm.showText(item).split(',')[0])+" ")]):_vm._e(),(_vm.showText(item).indexOf('导入') > -1 || _vm.showText(item).indexOf('替换') > -1)?_c('input',{ref:"file",refInFor:true,attrs:{"type":"file","id":"fileInput"},on:{"change":_vm.importDoc}}):_vm._e()],1)}),_vm._t("msg")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }